import { useMutation } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

interface SendEdi855Params {
  orderConfirmationId: string;
  /** If true, allows resending even if already sent */
  force?: boolean;
  /**
   * Send on Orderful's TEST stream, leaving this confirmation's real 855 status
   * untouched. Admin-only; the backend rejects it otherwise.
   */
  test?: boolean;
}

const useSendEdi855Transaction = (
  onSuccess?: () => void,
  onError?: () => void,
) => {
  return useMutation({
    mutationFn: (params: SendEdi855Params) =>
      orpc.edi.orderConfirmations.sendEdi855.call(params),
    onSuccess,
    onError,
  });
};

export default useSendEdi855Transaction;
